import { Box } from '@mui/material';
import { DriveContentType, IDriveContent } from 'src/@types/drive';
import FileThumbnail from 'src/components/file-thumbnail';

export const DriveExplorerLabel = ({
  driveItem,
}: { driveItem: IDriveContent }) => {
  return (
    <>
      {driveItem.type === DriveContentType.FOLDER ? (
        <Box
          component="img"
          src="/assets/icons/files/ic_folder.svg"
          sx={{ width: 20, height: 20 }}
        />
      ) : (
        <FileThumbnail
          file={driveItem.name}
          imgSx={{ width: 20, height: 20 }}
        />
      )}
      <span>{driveItem.name}</span>
    </>
  );
};
